import styled from 'styled-components';

export const StyledForm = styled.form`
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;
